import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
// vi: filetype=javascript.jsx
import { TextArea } from "@classdojo/web/nessie";
import { TEXT_FIELD_HEIGHT } from "@classdojo/web/nessie/components/TextField";
import React from "react";
import { ToolPayload } from "src/pods/toolkitData/components/EditableSetup";

type PairShareEditProps = {
  onEdit: (payload: ToolPayload, disabled?: boolean) => void;
  payload: ToolPayload;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class PairShareEdit extends React.Component<PairShareEditProps> {
  render() {
    return (
      <TextArea
        label={autoTranslate("Write out a question or topic you'd like students to discuss with their neighbor")}
        rows={3}
        onChange={this.onQuestionChange}
        value={this.props.payload ? this.props.payload.text : ""}
        fixedHeight={TEXT_FIELD_HEIGHT * 2}
      />
    );
  }

  onQuestionChange = (value: string) => {
    const text = value;
    this.props.onEdit({ text }, !text);
  };
}
